/* assets/wb-discount-sort.js */
(function () {
  // === API endpoint ===
  const ENDPOINT = "https://wb-discount-sort-live.vercel.app/api/reorder-by-discount";

  // Eğer API secret kullanıyorsan buraya ekle
  const SECRET = window.WB_SORT_SECRET || ""; 
  // Eğer gizlemek istiyorsan theme.liquid içine şöyle ekleyebilirsin:
  // <script>window.WB_SORT_SECRET = "{{ settings.wb_sort_secret }}";</script>

  const TRIGGER_SELECTOR = '[data-wb-discount-sort], .wb-discount-sort';

  // Shopify Collection GID çek
  function getCollectionGid() {
    const el = document.getElementById("wb-collection-gid");
    return el ? el.getAttribute("data-gid") : null;
  }

  // Basit toast mesajı
  function toast(msg) {
    try {
      const n = document.createElement("div");
      n.textContent = msg;
      n.style.cssText =
        "position:fixed;top:16px;right:16px;z-index:999999;background:#111;color:#fff;padding:10px 12px;border-radius:6px;font-size:13px";
      document.body.appendChild(n);
      setTimeout(() => n.remove(), 2200);
    } catch (e) {
      console.log(msg);
    }
  }

  // Sort dropdown'ları kapat
  function closeDropdown() {
    const open = document.querySelector('.filter-sortby .label-tab[aria-expanded="true"]');
    if (open) open.click();

    const openMobile = document.querySelector('.dropdown-menu[data-mobile="mobile"].is-open');
    if (openMobile) openMobile.classList.remove("is-open");
  }

  // === ASIL ÇALIŞAN FONKSİYON ===
  async function runSort() {
    const collectionId = getCollectionGid();

    if (!collectionId) {
      toast("Koleksiyon kimliği bulunamadı.");
      console.warn("[wb-sort] collection GID yok");
      return;
    }

    closeDropdown();
    toast("İndirime göre sıralama başlıyor…");

    try {
      const res = await fetch(ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(SECRET ? { "x-wb-secret": SECRET } : {})
        },
        body: JSON.stringify({ collectionId })
      });

      // HTTP error
      if (!res.ok) {
        console.error("[wb-sort] API error", res.status, await res.text());
        toast("İşlem sırasında bir hata oluştu.");
        return;
      }

      const data = await res.json().catch(() => ({}));
      console.log("[wb-sort] response:", data);

      // Başarılı işlem
      if (data.ok === true || data.moved > 0) {
        toast("Sıralama uygulandı. Sayfa yenileniyor…");
        setTimeout(() => location.reload(), 800);
      } else {
        toast("İşlem tamamlanamadı.");
      }
    } catch (err) {
      console.error("[wb-sort] fetch error", err);
      toast("Ağ hatası. Lütfen tekrar deneyin.");
    }
  }

  // === Elementlere click bağlama ===
  function bind() {
    const triggers = document.querySelectorAll(TRIGGER_SELECTOR);

    triggers.forEach((el) => {
      if (el.__wbBound) return; // tekrar bağlamayı önler
      el.__wbBound = true;

      if (el.tagName === "A") el.setAttribute("href", "javascript:void(0)");

      el.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        runSort();
      });

      el.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          runSort();
        }
      });
    });

    console.log("[wb-sort] triggers bound:", triggers.length);
  }

  document.addEventListener("DOMContentLoaded", bind);
  document.addEventListener("shopify:section:load", bind);
})();
